<template>
  <div class="my_home_container">
    <div class="my_home">
      <!-- 考勤打卡模块 -->
      <div class="attendance_wrapper">
        <div class="header_con">
          <div class="user_name">你好,&nbsp;{{ userInfo.user_name }}!</div>
          <div class="date">本月</div>
        </div>
        <div class="attendance_con">
          <div class="attendance_item">
            <div class="attendance_item_number">
              {{ attendanceInfo.lateDay >= 0 ? attendanceInfo.lateDay : "0" }}
            </div>
            <div class="attendance_item_title">迟到</div>
          </div>
          <div class="attendance_item">
            <div class="attendance_item_number">
              {{
                attendanceInfo.leaveEarlyDay >= 0
                  ? attendanceInfo.leaveEarlyDay
                  : "0"
              }}
            </div>
            <div class="attendance_item_title">早退</div>
          </div>
          <div class="attendance_item">
            <div class="attendance_item_number">
              {{
                attendanceInfo.awayDayTotal >= 0
                  ? attendanceInfo.awayDayTotal
                  : "0"
              }}
            </div>
            <div class="attendance_item_title">公出</div>
          </div>
          <div class="attendance_item">
            <div class="attendance_item_number">
              {{
                attendanceInfo.leaveDayTotal >= 0
                  ? attendanceInfo.leaveDayTotal
                  : "0"
              }}
            </div>
            <div class="attendance_item_title">请假</div>
          </div>
        </div>
        <div class="today_con">
          <div class="today_con_list">
            <div class="today_con_item" v-if="dayAttendanceInfo.mornLeave">
              <div class="day_content">上午</div>
              <div class="time_content">请假</div>
            </div>
            <div
              class="today_con_item"
              v-if="
                !(dayAttendanceInfo.mornLeave && dayAttendanceInfo.mornLeave)
              "
            >
              <div class="day_content">上班打卡</div>
              <div class="time_content">
                {{ dayAttendanceInfo.start?moment(dayAttendanceInfo.start).format("HH:mm") : "未打卡" }}
              </div>
            </div>
            <div
              class="today_con_item"
              v-if="
                !(dayAttendanceInfo.mornLeave && dayAttendanceInfo.mornLeave)
              "
            >
              <div class="day_content">下班打卡</div>
              <div class="time_content">
                {{ dayAttendanceInfo.end?moment(dayAttendanceInfo.end).format("HH:mm") : "未打卡" }}
              </div>
            </div>
            <div class="today_con_item" v-if="dayAttendanceInfo.afternoonLeave">
              <div class="day_content">下午</div>
              <div class="time_content">请假</div>
            </div>
          </div>
        </div>
      </div>

      <div class="todo_wrapper">
        <FrameWrapper title="代办工作" routerTo="/m/workFlowManage">
          <template slot="contentSlot">
            <div class="list_wrapper">
              <div
                class="item_wrapper"
                v-for="(item, index) in todoArray"
                :key="index"
                @click="goDetail(item)"
              >
                <div class="name cursor">
                  {{
                    item.variables
                      ? "流水号:" + item.variables.serialNumber + ";"
                      : ""
                  }}
                  {{ removeTime(item.processDefinitionName) }}
                </div>
                <div class="time cursor">
                  {{
                    item.createTime
                      ? moment(item.createTime).format("YYYY-MM-DD")
                      : "/"
                  }}
                </div>
              </div>
            </div>
          </template>
        </FrameWrapper>
      </div>
      <div class="todo_wrapper">
        <FrameWrapper title="会议安排">
          <template slot="contentSlot">
            <div class="list_wrapper">
              <a-skeleton active v-if="meetLoading" />
              <div
                class="item_wrapper"
                v-for="(item, index) in meetArray"
                :key="index"
              >
                <div class="name cursor">
                  {{
                    item.meetingPlanStartTime
                      ? moment(item.meetingPlanStartTime).format(
                          "YYYY-MM-DD HH:mm"
                        )
                      : "/"
                  }}
                </div>
                <div class="time cursor">
                  {{ item.name }}
                  <span class="address">{{ item.meetingAddress }}</span>
                </div>
              </div>
              <div
                class="empty_wrapper"
                v-if="meetArray.length == 0 && !meetLoading"
              >
                <a-empty description="暂无数据" />
              </div>
            </div>
          </template>
        </FrameWrapper>
      </div>
      <div class="custer_visit_wrapper">
        <div class="custer_visit_flex">
          <FrameCount title="总客户数">
            <template slot="rightSlot">
              <div class="right_wrapper">
                月<a-icon class="right_icon" type="caret-up" />{{
                  dataInfo.cust.monthTotal
                }}
                个
              </div>
            </template>

            <template slot="contentSlot">
              <div class="content_wrapper">
                <div class="total">{{ getMoney(dataInfo.cust.total) }}</div>
                <div class="img_chart">
                  <div class="img_chart_icon">
                    <img src="/img/mobile/zkhs.svg" alt />
                  </div>
                </div>
              </div>
            </template>
          </FrameCount>
        </div>
        <div class="custer_visit_flex">
          <FrameCount title="总拜访数">
            <template slot="rightSlot">
              <div class="right_wrapper">
                月<a-icon class="right_icon" type="caret-up" />{{
                  dataInfo.visit.monthTotal
                }}个
              </div>
            </template>
            <template slot="contentSlot">
              <div class="content_wrapper">
                <div class="total">{{ getMoney(dataInfo.visit.total) }}</div>
                <div class="img_chart">
                  <div class="img_chart_icon">
                    <img src="/img/mobile/zbfs.svg" alt />
                  </div>
                </div>
              </div>
            </template>
          </FrameCount>
        </div>
      </div>
      <div class="transaction_wrapper">
        <FrameTransaction
          title="基金业务"
          
          :dataList="fundList"
          :isSubtitle="true"
          :dataInfo="dataInfo"
        />
        <div class="border_bottom">
          
        </div>
        <FrameTransaction
            :dataList="otherList"
            :isSubtitle="true"
            :dataInfo="dataInfo"
          />
      </div>
    </div>
  </div>
</template>



<script>
import workFlow from "@/mixins/workFlow";
import moment from "moment";
import { summary } from "@/api/desk/desk";
import { getAttendanceList, sumarizationDay } from "@/api/hr/attendance";
import { mapGetters } from "vuex";
import FrameWrapper from "./components/frame";
import FrameCount from "./components/frameCount";
import FrameTransaction from "./components/frameTransaction";
import { todoList } from "@/api/plugin/workflow/process";
import { getList } from "@/api/meeting/meetingcategory";
export default {
  name: "myHome",
  mixins: [workFlow],
  data() {
    return {
      dataInfo: {
        cust: {
          monthTotal: 0,
          total: 0,
        },
        visit: {
          monthTotal: 0,
          total: 0,
        },

        bl: {},

        summary: {},
        govSummary: {},
        otherSummary: { value: 0, scale: 0 },
        rzzl: { value: 0, scale: 0 },
        selfSummary: { value: 0, scale: 0 },
        zd: { value: 0, scale: 0 },
      },
      fundList: [
        {
          subtitle: "政府产业基金",
          permission:"fdoffunds_view",
          subList: [
            { labelName: "子基金", valueName: "govFund", monthTotalUnit: "个" },
            {
              labelName: "直投项目",
              valueName: "govProject",
              monthTotalUnit: "个",
            },
            {
              labelName: "非直投项目",
              valueName: "govBasicProject",
              monthTotalUnit: "个",
            },
          ],
        },
        {
          subtitle: "自营基金",
          permission:"fdoffunds_view",
          subList: [
            {
              labelName: "子基金",
              valueName: "selfFund",
              monthTotalUnit: "个",
            },
            {
              labelName: "直投项目",
              valueName: "selfProject",
              monthTotalUnit: "个",
            },
            {
              labelName: "非直投项目",
              valueName: "selfBasicProject",
              monthTotalUnit: "个",
            },
          ],
        },
        {
          subtitle: "纾困基金",
          permission:"fdoffunds_view",
          subList: [
            {
              labelName: "子基金",
              valueName: "otherFund",
              monthTotalUnit: "个",
            },
            {
              labelName: "投资项目",
              valueName: "otherProject",
              monthTotalUnit: "个",
            },
          ],
        },
      ],
      otherList: [
        {
          subtitle: "融资租赁",
          permission: "pmmproject_view",
          subList: [
            {
              labelName: "投资笔数",
              valueName: "rzzlCount",
              monthTotalUnit: "笔",
            },
            {
              labelName: "服务家数",
              valueName: "rzzlCustCount",
              monthTotalUnit: "家",
            },
            {
              labelName: "投资总金额",
              valueName: "rzzlAmount",
              isMoney: true,
              totalUnit: "亿元",
              monthTotalUnit: "万元",
            },
          ],
        },
        {
          subtitle: "保理业务",
          permission: "factoringProjectManage_view",
          subList: [
            {
              labelName: "投资笔数",
              valueName: "blCount",
              monthTotalUnit: "笔",
            },
            {
              labelName: "服务家数",
              valueName: "blCustCount",
              monthTotalUnit: "家",
            },
            {
              labelName: "投资总金额",
              valueName: "blAmount",
              isMoney: true,
              totalUnit: "亿元",
              monthTotalUnit: "万元",
            },
          ],
        },
        {
          subtitle: "转贷业务",
          permission: "project_view",
          subList: [
            {
              labelName: "投资笔数",
              valueName: "zdCount",
              monthTotalUnit: "笔",
            },
            {
              labelName: "服务家数",
              valueName: "zdCustCount",
              monthTotalUnit: "家",
            },
            {
              labelName: "投资总金额",
              valueName: "zdAmount",
              isMoney: true,
              totalUnit: "亿元",
              monthTotalUnit: "万元",
            },
          ],
        },
      ],
      attendanceInfo: {},
      dayAttendanceInfo: {},
      page: {
        pageSize: 6,
        currentPage: 1,
        total: 0,
      },
      todoLoading: true,
      meetLoading: true,
      myDeskLoading: true,
      todoArray: [],
      meetArray: [],
      myDeskArray: [],
    };
  },
  components: {
    FrameWrapper,
    FrameCount,
    FrameTransaction,
  },
  computed: {
    ...mapGetters(["permission", "userInfo"]),
    removeTime() {
      return function (name) {
        name = (name + "").replace(/\([^\)]*\)/g, "");
        return name;
      };
    },
  },
  mounted() {
    this.getAttendance();
    this.getArray();
    this.getInfo();
  },
  methods: {
    moment,
    //代办跳转详情
    goDetail(row) {
      if (row.detailFormUrl) {
        let redirectInfo = JSON.parse(row.detailFormUrl);
        this.$router.push({
          path: `/m${redirectInfo.url}/${redirectInfo.id}`,
        });
      }
    },

    // 获取考勤统计
    async getAttendance() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        userName: this.userInfo.user_name,
        nameList: this.userInfo.user_id,
        month: moment().format("YYYY-MM-01"),
      };
      let res = await getAttendanceList(params);
      if (res.data.code == 200) {
        let data = res.data.data.records;
        if (data && data.length > 0) {
          this.attendanceInfo = data[0];
        }
      }

      let result = await sumarizationDay({
        month: moment().format("YYYY-MM-DD"),
        name: this.userInfo.user_name,
      });
      if (result.data.code == 200) {
        let data = result.data.data;
        data.mornLeave = false;
        data.afternoonLeave = false;
        data.events.map((el, index_) => {
          if (el.eventType == 2) {
            if (el.endTime.isBefore(moment().format("YYYY-MM-DD 14:30"))) {
              // 上午请假
              data.mornLeave = true;
            }
            if (el.endTime.isBefore(moment().format("YYYY-MM-DD 23:59"))) {
              if (el.vacationDay >= 1) {
                // 上下午都请了
                data.mornLeave = true;
                data.afternoonLeave = true;
              } else {
                //  下午请假
                data.afternoonLeave = true;
              }
            }
          }
        });
        this.dayAttendanceInfo = data;
      }
    },
    // 待办事项 会议安排
    getArray() {
      this.todoLoading = true;
      this.meetLoading = true;
      this.myDeskLoading = true;

      // 待办事项 列表
      todoList(this.page.currentPage, this.page.pageSize).then((res) => {
        const data = res.data.data;
        this.todoArray = data.records;
        this.todoLoading = false;
      });

      // 会议安排列表
      getList(
        this.page.currentPage,
        this.page.pageSize,
        Object.assign(
          {},
          { meetingTimeFloor: this.moment().format("YYYY-MM-DD HH:mm:ss") }
        )
      ).then((res) => {
        const data = res.data.data;
        this.meetArray = data.records;
        this.meetLoading = false;
      });
    },

    // 获取数据统计数据
    getInfo() {
      //
      summary({}).then((res) => {
        if (res.data.code == 200) {
          const data = res.data.data;
          data.summary = {
            ...data.bl,
            ...data.zd,
          };
          this.dataInfo = data;
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
$base_width: 375;
@function pxRem($px) {
  @return ($px / $base_width) * 10 + rem;
}

.my_home_container {
  position: relative;
  overflow: hidden;
  height: 100%;
}

/* for Chrome */
.my_home::-webkit-scrollbar {
  display: none;
}

.my_home {
  position: absolute;
  left: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  height: 100%;
  width:100%;
  .attendance_wrapper {
    background-image: url("/img/mobile/home_bg.png");
    background-size: cover;
    width: 100%;
    height: pxRem(270);
    background-color: #F5F5F5;
    .header_con {
      display: flex;
      font-size: pxRem(18);
      color: rgb(255, 255, 255);
      font-weight: 400;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: pxRem(20);
      .user_name {
      }
      .date {
        font-size: pxRem(12);
      }
    }
    .attendance_con {
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 0 pxRem(20);
      .attendance_item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .attendance_item_number,
        .attendance_item_title {
          font-weight: 700;
          font-size: pxRem(18);
          color: rgb(255, 255, 255);
        }
        .attendance_item_number {
          padding-bottom: pxRem(10);
        }
      }
    }
    .today_con {
      padding:0 pxRem(10);
      margin-top:pxRem(24);
      
      .today_con_list {
        display: flex;
        align-items: center;
        justify-content: space-around;
        // padding-top: pxRem(33);
        width: 100%;
        height: pxRem(80);
        background-image: url("/img/mobile/home_toady_bg.png");
        background-size: cover;
        box-shadow: 0px 0px pxRem(5) rgba(0, 0, 0, 0.47);
        border-radius: pxRem(8);
        
        .today_con_item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .day_content {
            color: #333333;
            font-size: pxRem(14);
            font-weight: 400;
          }
          .time_content {
            color: #4b7ef1;
            font-size: pxRem(16);
            font-weight: 700;
            padding-top: pxRem(6);
          }
        }
      }
    }
  }
  .todo_wrapper {
    .list_wrapper {
      padding: 0 pxRem(20);
      height: pxRem(236);
      .item_wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        line-height: pxRem(38);
        .name {
          color: #666666;
          font-size:  pxRem(13);
          display: flex;
          align-items: center;

          flex: 1;
        }
        .home_list_icon {
          height: pxRem(18);
          width: pxRem(18);
          display: inline-block;
        }

        .time {
          color: #666666;
          font-size: pxRem(13);
          margin-left: pxRem(20);

          .address {
            margin-left: pxRem(15);
          }
        }
        .cursor {
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
        }
        .cursor:hover {
          color: #409eff;
          text-decoration: underline;
        }
      }
    }
  }
  .custer_visit_wrapper {
    display: flex;
    background-color: #f5f5f5;
    padding: 0.26rem 0 0.26rem 0.26rem;
    .custer_visit_flex {
      width: calc(49% - 0.26rem);
      margin-right: 0.26rem;
      //   height: 100px;
      flex: 1;
      background-color: #fff;
      .right_wrapper {
        display: flex;
        align-items: center;
        font-size: pxRem(13);

        .right_icon {
          color: #f95e5a;
        }
      }
      .content_wrapper {
        padding: 0 pxRem(10);
        .total {
          color: #333333;
          font-size: pxRem(20);
          font-weight: 700;
        }
        .img_chart {
          display: flex;
          align-items: center;
          justify-content: center;
          .img_chart_icon img {
            width: 100%;
            height: pxRem(32);
            text-align: center;
          }
        }
      }
    }
  }
}
.border_bottom {
    height:pxRem(10);
    background-color:#f5f5f5;
}
</style>